<section class="h-full">
  <header class="main-header">
    <h2 class="title">Manage Views & Saved Filters</h2>
    <p class="subtitle">Use tabs below to navigate between views and saved filters</p>
  </header>
  <mat-divider></mat-divider>
  <mat-tab-group #manageViewsTabGroup mat-stretch-tabs animationDuration="0">
    <!-- Manage Views Tab -->
    <mat-tab class="manage-views">
      <ng-template mat-tab-label>
        <header class="manage-views__header">
          <p>Views</p>
        </header>
      </ng-template>

      <main class="manage-views__body">
        <section class="body-content">
          <form [formGroup]="pipelinesForm">
            <section class="body-description">
              <div class="select-views-group">
                @if (!!pipelines && !!selectViewGroup) {
                <button
                  class="more-menu"
                  mat-icon-button
                  [matMenuTriggerFor]="groupOptionsMenu"
                  *ngIf="selectedViewGroup && selectedViewGroup.label !== 'No Group'"
                  data-cy="view-group-options"
                >
                  <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                </button>
                }
                <mat-menu #groupOptionsMenu="matMenu">
                  <ng-container>
                    <button
                      mat-menu-item
                      (click)="deleteGroup(selectedViewGroup?.id)"
                      [disabled]="selectedViewGroup?.members?.length > 0"
                      data-cy="view-group-delete-button"
                    >
                      <mat-icon [svgIcon]="'delete'"></mat-icon>
                      <span>Delete Group</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="editGroup()">
                    <mat-icon [svgIcon]="'edit'"></mat-icon>
                    <span>Edit Group</span>
                  </button>
                </mat-menu>
                <h4 class="title" data-cy="view-group-selected">{{ selectedViewGroup?.label | uppercase }}</h4>
                <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Change Group" *ngIf="selectedViewGroup">
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="selectViewGroup(group)" *ngFor="let group of viewGroups">
                    {{ group.label }}
                  </button>
                </mat-menu>
              </div>

              @if (!!pipelines && !!selectViewGroup) {
              <div class="controllers-wrapper" [formGroupName]="'newPipeline'">
                <button
                  class="create-view-button"
                  mat-flat-button
                  [color]="'primary'"
                  (click)="createMember()"
                  data-cy="create-view"
                >
                  <mat-icon [svgIcon]="'add'"></mat-icon>
                  Create View
                </button>
                <button
                  class="reorder-group-button ml-4"
                  mat-flat-button
                  [color]="'primary'"
                  (click)="reorderGroups()"
                  data-cy="reorder-groups"
                >
                  <mat-icon [svgIcon]="'reorder'"></mat-icon>
                  Reorder Groups
                </button>
                <button
                  class="create-group-button ml-4"
                  mat-flat-button
                  [color]="'primary'"
                  (click)="createGroup()"
                  data-cy="create-view-group"
                >
                  <mat-icon [svgIcon]="'add'"></mat-icon>
                  Create Group
                </button>
              </div>
              }
            </section>
            <mat-divider></mat-divider>
            <div
              data-cy="view-list"
              class="list"
              [formArrayName]="'pipelines'"
              cdkDropList
              [cdkDropListData]="pipelinesForm.get('pipelines')['controls']"
              (cdkDropListDropped)="dropped($event)"
            >
              <div class="item" *ngFor="let pipeline of pipelinesForm.get('pipelines')['controls']" cdkDrag>
                <div class="drag-handle" cdkDragHandle>
                  <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                </div>
                <mat-form-field>
                  <mat-label>View</mat-label>
                  <mat-icon class="mr-2" [svgIcon]="getViewIcon(pipeline)"></mat-icon>
                  <input matInput [formControl]="pipeline.get('name')" (blur)="updateMember()" />
                  <button
                    mat-icon-button
                    matSuffix
                    [matTooltip]="
                      pipeline.get('is_editable').value ? 'Edit' : 'You don\'t have permission to edit this view'
                    "
                    [disabled]="!pipeline.get('is_editable').value"
                    (click)="moveMemberToGroup(pipeline?.value)"
                    data-cy="view-edit-button"
                  >
                    <mat-icon class="action-icon" [svgIcon]="'edit'"></mat-icon>
                  </button>
                  <ng-container *ngIf="pipeline.get('visibility').value === 'public_visibility'">
                    <button
                      mat-icon-button
                      matSuffix
                      [matTooltip]="
                        pipeline.get('is_editable').value
                          ? 'Make view private'
                          : 'You don\'t have permission to change visibility'
                      "
                      [disabled]="!pipeline.get('is_editable').value"
                      (click)="toggleViewVisibility(pipeline, 'private_visibility')"
                    >
                      <mat-icon class="action-icon" [svgIcon]="'lock_open'"></mat-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="pipeline.get('visibility').value === 'private_visibility'">
                    <button
                      mat-icon-button
                      matSuffix
                      [matTooltip]="
                        pipeline.get('is_editable').value
                          ? 'Make view public'
                          : 'You don\'t have permission to change visibility'
                      "
                      [disabled]="!pipeline.get('is_editable').value"
                      (click)="toggleViewVisibility(pipeline, 'public_visibility')"
                    >
                      <mat-icon class="action-icon" [svgIcon]="'lock'"></mat-icon>
                    </button>
                  </ng-container>
                  <button
                    mat-icon-button
                    matSuffix
                    [matTooltip]="
                      !isViewDeleteBtnDisabled(pipeline) ? 'Delete' : 'You don\'t have permission to delete this view'
                    "
                    [disabled]="isViewDeleteBtnDisabled(pipeline)"
                    (click)="deleteMember(pipeline.get('id').value)"
                    data-cy="view-delete-button"
                  >
                    <mat-icon class="action-icon" [svgIcon]="'delete'"></mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          </form>
        </section>
      </main>
    </mat-tab>

    <!-- Manage Filters Tab -->
    <mat-tab class="manage-filters">
      <ng-template mat-tab-label>
        <header class="manage-filters__header">
          <p>Saved Filters</p>
        </header>
      </ng-template>

      <main class="manage-filters__body">
        <section class="body-content">
          <form [formGroup]="savedFiltersForm">
            <section class="body-description">
              <p class="title">Update and delete saved filters.</p>
            </section>
            <mat-divider></mat-divider>
            <div class="list" [formArrayName]="'savedFilters'">
              <div class="item" *ngFor="let savedFilter of savedFiltersForm.get('savedFilters')['controls']">
                <mat-form-field>
                  <input matInput [formControl]="savedFilter.get('name')" (blur)="updatedSavedFilter()" />
                  <button mat-icon-button matSuffix (click)="deleteSavedFilter(savedFilter.get('id').value)">
                    <mat-icon [svgIcon]="'delete'"></mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          </form>
        </section>
      </main>
    </mat-tab>
  </mat-tab-group>
</section>
